module.exports = __webpack_public_path__ + "img/schemeList05Display04.0f83d8b6.jpg";